import type { ReactNode } from 'react';
import type { MatchSummary } from './head-to-head.utils';

interface MatchSummaryDisplayProps {
  summary: MatchSummary | undefined;
}

export const MatchSummaryDisplay = ({ summary }: MatchSummaryDisplayProps): ReactNode => {
  if (!summary) {
    return '(Never Played)';
  }

  // Check if any matches have been played
  if (summary.won === 0 && summary.lost === 0 && summary.halved === 0) {
    return '(Never Played)';
  }

  const greyStyle = { color: '#CCC' };

  return (
    <span>
      (<span style={summary.won === 0 ? greyStyle : undefined}>W{summary.won}</span>-
      <span style={summary.halved === 0 ? greyStyle : undefined}>H{summary.halved}</span>-
      <span style={summary.lost === 0 ? greyStyle : undefined}>L{summary.lost}</span>)
    </span>
  );
};
